<template>
  <div class="EditInspectionSectionItem">
    <div class="boon-form-container" :class="{ archived: sectionItem.archived }">
      <b-icon v-if="sectionItem.new" icon="plus" />
      <b-icon v-if="!sectionItem.new" icon="grip-horizontal" class="glyphicon-move" />

      <icon-selector class="h2" :value="sectionItem.icon" @input="updateProperty('icon', $event)" />
      <translated-field
        ref="title"
        :label="sectionItem.new ? $t('Add New') : $t('Title')"
        :value="sectionItem.title"
        :readonly="sectionItem.archived"
        class="half mx-4 my-2"
        @input="updateProperty('title', $event)"
      />

      <translated-field
        v-if="!sectionItem.new"
        :label="$t('Description')"
        :value="sectionItem.description"
        :readonly="sectionItem.archived"
        class="half mx-4 my-2"
        @input="updateProperty('description', $event)"
      />

      <iconToggle
        v-if="!sectionItem.new"
        :value="sectionItem.archived"
        @input="updateProperty('archived', $event)"
        iconOff="static/icon/H2BOON-list-missing.png"
        iconOn="static/icon/H2BOON-list-plus.png"
        class="right"
        :tab="false"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import iconToggle from '@/components/iconToggle/iconToggle';
import IconSelector from '@/components/IconSelector';
import TranslatedField from '@/components/form/TranslatedField';

import getRef from '@/utils/getRef';

export default {
  name: 'EditInspectionTemplateSectionItem',

  components: {
    iconToggle,
    IconSelector,
    TranslatedField,
  },

  props: {
    template: {
      type: Object,
      required: true,
    },
    sectionItem: {
      type: Object,
      default: () => ({ new: true, title: {} }),
    },
    sectionId: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  methods: {
    ...mapActions(['saveInspectionSectionItemProperties']),

    updateProperty: function (property, value) {
      if (this.sectionItem[property] !== value) {
        this.saveInspectionSectionItemProperties({
          updateInspectionTemplate: this.template,
          inspectionSectionId: this.sectionId,
          itemIndex: this.index,
          newInspectionSectionItemProperties: { [property]: value },
        });
      }
    },

    focus: function () {
      const ref = getRef(this.$refs, 'title');
      if (ref) {
        ref.focus();
      }
    },
  },
};
</script>

<style scoped>
img.icon {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}
.boon-form-container {
  display: flex;
  flex-direction: row;
  padding: 20px 0;
  margin: 0 30px;
}

.glyphicon-move {
  color: #ffffff;
  width: inherit;
  margin: 3px;
}

.archived {
  color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditInspectionTemplateSectionItem.vue